module.exports = __webpack_public_path__ + "img/blank_card_mastercard.d23d984a.png";